import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createBlogTag } from "../../api/apiBlogTags";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لإنشاء وسام مدونة جديد
 */
export function useCreateBlogTag() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createBlogTagMutate,
        isPending,
    } = useMutation({
        mutationFn: createBlogTag,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-tags"] });
            navigate('/blog/tags');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create blog tag");
        },
    });

    return {
        createBlogTagMutate,
        isPending,
    };
}
